import "../styles/App.css";
import React, { useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import ThreeViewer from "../components/ThreeViewer";

function Preview() {
  const [searchParams] = useSearchParams();
  const urlValue = searchParams.get("url");

  const viewerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);

  const loaderVRM = () => {
    if (viewerRef.current) {
      viewerRef.current.loadModel(urlValue);
      setActive(true);
    }
  };

  // const downloadVRM = () => {
  //   if (viewerRef.current) {
  //     viewerRef.current.downloadVRM();
  //   }
  // };

  return (
    // <div>
    <div style={{ width: "100%", height: "100vh" }}>
      {!active && (
        <button className="start" onClick={loaderVRM}>
          View Model
        </button>
      )}
      {/* <button className="download" onClick={downloadVRM}>
        Download Model
      </button> */}
      {loading && <p className="loading">LOADING...</p>}
      <ThreeViewer
        ref={viewerRef}
        loadState={setLoading}
      />

    </div>
  );
}

export default Preview;
